import ApiService from "./ApiService";

export async function apiSignIn(data) {
  return await ApiService.fetchData({
    url: "/api/v1/user/auth/login",
    method: "post",
    data,
  });
}

export async function apiSignUp(data) {
  return ApiService.fetchData({
    url: "/sign-up",
    method: "post",
    data,
  });
}

export async function apiSignOut(data) {
  return ApiService.fetchData({
    url: "/api/v1/user/auth/logout",
    method: "post",
    data,
  });
}

export async function apiForgotPassword(data) {
  return ApiService.fetchData({
    url: "/api/v1/user/email/forget-password",
    method: "post",
    data,
  });
}

export async function apiResetPassword(data) {
  return ApiService.fetchData({
    url: "/api/v1/user/auth/reset-password",
    method: "put",
    data,
  });
}
